import { useQuery } from "react-query";
import api from "../api";

export const useGetOrderDetailsById = (id) => {
  return useQuery(["order-details", id], () => {
    if (id !== undefined) {
      return api.get(`/property/${id}/order-detail`).then((res) => res.data);
    }
  });
};
